import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { pickHTMLProps } from 'pick-react-known-prop';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
var useStyles = makeStyles(function (theme) {
  return {
    root: {},
    'button-highlighted': {
      backgroundColor: theme.palette.primary.dark
    },
    paginationButton: {}
  };
}, {
  name: 'SxComProductListPagerClassicPaginationButton'
});

function ProductListPagerClassicPaginationButton(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      highlighted = _ref.highlighted,
      onChangePage = _ref.onChangePage,
      pageIndex = _ref.pageIndex,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "highlighted", "onChangePage", "pageIndex"]);

  var classes = useStyles({
    classes: pClasses
  });

  var handleButtonChangePage = function handleButtonChangePage(page) {
    return function () {
      if (onChangePage) {
        onChangePage(page);
      }
    };
  };

  var buttonHighlighted = highlighted === true ? _defineProperty({}, classes["button-highlighted"], true) : '';
  return /*#__PURE__*/React.createElement(Button, _extends({}, pickHTMLProps(rest), {
    onClick: handleButtonChangePage(pageIndex),
    className: clsx(classes.root, className, buttonHighlighted)
  }), pageIndex + 1);
}

ProductListPagerClassicPaginationButton.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string,
  highlighted: PropTypes.bool,
  onChangePage: PropTypes.func.isRequired,
  pageIndex: PropTypes.number
};
ProductListPagerClassicPaginationButton.defaultProps = {
  classes: undefined,
  className: undefined,
  highlighted: false,
  pageIndex: undefined
};
export default ProductListPagerClassicPaginationButton;